import React, { useEffect, useState } from "react";
import {
	Flex,
	Input,
	Button,
	Heading,
	Image,
	useToast,
	Stack,
	useMediaQuery,
} from "@chakra-ui/react";
import mutualLogo from "../../img/asoemlogo.png";
import { useLogin } from "../../data/useLogin";
import SupervisorCounters from "./SupervisorCounters";

export default function Login({
	setUserLogged,
	params,
	setSupervisorData,
	supervisorData,
}) {
	const {
		titulo_web: title,
		mensaje_sos: errorMessage,
		modo_consulta: modoConsulta,
		evento: event,
		contador1_numero,
		contador1_titulo,
		contador2_numero,
		contador2_titulo,
		contador3_numero,
		contador3_titulo,
	} = params;

	const [isDesktop] = useMediaQuery("(min-width: 600px)");

	const toast = useToast();

	const { mutate: loginRequest, isPending: isSubmitting } = useLogin();

	const [user, setUser] = useState();
	const [password, setPassword] = useState();

	const handleUserChange = (e) => {
		setUser(e.target.value);
	};
	const handlePasswordChange = (e) => {
		setPassword(e.target.value);
	};

	const resetFields = () => {
		setUser("");
		setPassword("");
	};

	const handleLogin = () => {
		loginRequest(
			{ user, password, event, supervisorDNI: supervisorData?.user?.documento },
			{
				onSuccess: (data) => {
					if (data.categoria === "SUPERVISOR" && isDesktop) {
						setSupervisorData({ isSupervisor: true, user: data });
						resetFields();
						toast({
							title: "Ingreso como Supervisor",
							colorScheme: "green",
							position: "top",
						});
					} else {
						setUserLogged(data);
					}
				},
				onError: () => {
					resetFields();
					toast({
						title: "Comprueba los datos ingresados",
						colorScheme: "red",
						position: "top-right",
					});
				},
			}
		);
	};

	useEffect(() => {
		setUserLogged(null);
	}, []);

	const disableFields = errorMessage && modoConsulta !== "SI";

	return (
		<Flex
			h="100vh"
			w="100vw"
			bg="#e3e4e6"
			alignItems="center"
			direction="column"
		>
			{supervisorData.isSupervisor && (
				<>
					<Stack
						color="#fed700"
						position={"absolute"}
						left="5"
						gap={0}
						alignItems={"center"}
					>
						<Heading fontSize={"20px"} m={0}>
							SUPERVISOR
						</Heading>
						<Flex>{supervisorData.user.documento}</Flex>
					</Stack>
					<SupervisorCounters
						contador1_numero={contador1_numero}
						contador1_titulo={contador1_titulo}
						contador2_numero={contador2_numero}
						contador2_titulo={contador2_titulo}
						contador3_numero={contador3_numero}
						contador3_titulo={contador3_titulo}
					/>
				</>
			)}
			<Flex
				w={"100%"}
				bg="#555"
				color="#fafafa"
				justifyContent={"center"}
				p={3}
			>
				Hechos, No Palabras
			</Flex>
			<Flex
				w={"100%"}
				bg="#fff"
				color="#fafafa"
				justifyContent={"center"}
				p={4}
			>
				<Image src={mutualLogo} w="65%" maxW="300px" />
			</Flex>
			<Flex
				bg="#f9fad2"
				direction={"column"}
				width={"100%"}
				alignItems={"center"}
				flex={1}
			>
				<Heading my={3} fontSize={20}>
					{title}
				</Heading>
				{errorMessage && (
					<Heading my={1} fontSize={22} color="red">
						{errorMessage}
					</Heading>
				)}
				<Flex
					direction="column"
					alignItems="flex-start"
					w="85%"
					maxWidth="350px"
					p="10px 15px"
				>
					<Heading size="sm" mb="1" color="#555">
						Documento
					</Heading>
					<Input
						borderColor="black"
						type="text"
						value={user}
						onChange={handleUserChange}
						fontWeight="bolder"
						placeholder={"Ingrese Documento"}
						bg={"#fff"}
						disabled={disableFields}
					/>
					<Heading size="sm" my="1" color="#555" mt={4}>
						N° Legajo
					</Heading>
					<Input
						borderColor="black"
						value={password}
						onChange={handlePasswordChange}
						fontWeight="bolder"
						placeholder={"Ingrese N° Legajo"}
						bg={"#fff"}
						disabled={disableFields}
					/>
					<Button
						mt={10}
						colorScheme="yellow"
						_hover={{
							bg: "#ecc94b",
						}}
						isLoading={isSubmitting}
						onClick={handleLogin}
						alignSelf="center"
						w="65%"
						isDisabled={!user || !password || disableFields || isSubmitting}
					>
						{modoConsulta === "SI" ? "Consultar" : "Ingresar"}
					</Button>
				</Flex>
			</Flex>
			<Flex
				w={"100%"}
				bg="#fed700"
				color="#000"
				justifyContent={"center"}
				p={3}
				fontWeight={600}
			>
				Oficina Virtual
			</Flex>
		</Flex>
	);
}
